import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';

import { FormattedMessage } from 'react-intl';
import Html from './Html';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/award.module.scss';

import Gemeaux from '../../../img/awards/gemeaux.svg';
import Numix from '../../../img/awards/numix.png';
import Crea from '../../../img/awards/crea.png';

const logos = {
    award: Numix,
    gemeaux: Gemeaux,
    numix: Numix,
    crea: Crea,
};

const propTypes = {
    award: AppPropTypes.award,
    inverted: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    award: null,
    inverted: false,
    className: null,
};

const Award = ({ award, inverted, className }) => {
    const { type = null, name = null, description = null } = award || {};
    const image = useMemo(() => get(logos, type, null) || null);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.inverted]: inverted,
                    [styles.monochrome]: true,
                    [styles.withoutImage]: image === null,
                },
            ])}
        >
            {image !== null ? (
                <img className={styles.logo} src={image} alt={type} draggable="false" />
            ) : (
                <p className={styles.surtitle}>
                    <FormattedMessage defaultMessage="Prize" description="Prize top label" />{' '}
                </p>
            )}
            {name !== null ? <h2 className={styles.name}>{name}</h2> : null}
            {description !== null ? (
                <Html className={styles.description} body={description} />
            ) : null}
        </div>
    );
};

Award.propTypes = propTypes;
Award.defaultProps = defaultProps;

export default Award;
